export const path = {
    HOME: '/',
    HOMEPAGE: '/homepage',
    LOGIN: '/login',
    LOG_OUT: '/logout',
    SYSTEM: '/system'
};

export const actionsManage = {
    CREATE: "create",
    EDIT: "edit"
}

export const languages = {
    VI: 'vi',
    EN: 'en'
};

export const manageActions = {
    CREATE: "CREATE",
    READ: "READ",
    EDIT: "EDIT",
    DELETE: "DELETE"
};

export const dateFormat = {
    SEND_TO_SERVER: 'DD/MM/YYYY'
};

export const YesNoObj = {
    YES: 'Y',
    NO: 'N'
}